<template>
    <div>
    <div class="py-3"></div>
    
    <v-card
        class="mx-auto"
        max-width="90%"
    >
    <v-toolbar
        :color="`light-blue darken-3`"
        dark
    >    
    <v-toolbar-title>사전예약 등록 통계</v-toolbar-title>
    <v-spacer></v-spacer>
    </v-toolbar>

    
    <v-list> 
        <v-list-item>
        <span style="width:140px"><v-card-title style="font-weight:bold">날짜 선택</v-card-title></span>        
        <!-- ====================== 시작 날짜를 지정합니다 ====================== -->
        <!-- <v-col cols="12" lg="6"> -->
        <span style="width:120px">
        <v-menu
            v-model="date_picker_1"
            :close-on-content-click="false"
            max-width="290"
        >
        <template v-slot:activator="{ on, attrs }">
            <v-text-field
                :value="computedDateFormattedMomentjs_begin"
                clearable
                label="시작날짜"
                readonly
                v-bind="attrs"                
                v-on="on"
                hide-details
                @click:clear="start_date = null"
            ></v-text-field>
        </template>
        <v-date-picker
            v-model="start_date"
            @change="date_picker_1 = false"
        ></v-date-picker>
        </v-menu>
        </span>
    
    <!-- </v-col> -->
    <span style="width:60px"/>
    ~
    <!-- ====================== SPACE ====================== -->
    <span style="width:60px"/>
    <!-- ====================== 시작 날짜를 지정합니다 ====================== -->
        <!-- <v-col cols="12" lg="6"> -->
            
    <span style="width:120px">
        <v-menu
            v-model="date_picker_2"
            :close-on-content-click="false"
            max-width="290"
        >
        <template v-slot:activator="{ on, attrs }">
            <v-text-field
                :value="computedDateFormattedMomentjs_end"
                clearable
                label="종료날짜"
                readonly
                v-bind="attrs"
                v-on="on"
                hide-details
                @click:clear="end_date = null"
            ></v-text-field>
        </template>
        <v-date-picker
            v-model="end_date"
            @change="date_picker_2 = false"
        ></v-date-picker>
        </v-menu>
        </span>
        <v-spacer></v-spacer>
        <!--       
         <v-btn width="120px"  color="blue-grey lighten-3"  @click="OnSearch_Event_Today">오늘</v-btn>
         -->
        <v-spacer></v-spacer>            
        <v-btn width="120px"  color="lime accent-3"  @click="OnSearch_Event">검색하기</v-btn>
        </v-list-item>
        
        <!-- 지급 상품  -->
        <!-- 유효 기간  -->
        <!-- 등록 하기  -->



    </v-list>
    </v-card>

    <div class="py-3"></div>
    
    <v-card
        class="mx-auto"
        max-width="90%"
    >
    <v-toolbar
        :color="`light-blue darken-3`"
        dark
    >    
    <v-toolbar-title>패키지 선택</v-toolbar-title>
    <v-spacer></v-spacer>
    </v-toolbar>
        <div class="pa-3">
            <v-row>
                <v-col>
                    <v-select
                        v-model="selcetedPackage"
                        :items="filterdPackage"
                        label="프로젝트그룹 선택"
                        item-text="package"
                        item-value="package"
                        filled
                        outlined
                        dense
                        hide-details
                    ></v-select>
                </v-col>
                <v-col>
                </v-col>
            </v-row>

        </div>
    </v-card>
    
    <div class="py-3"></div>



    <v-card
        class="mx-auto"
        max-width="90%"
    >
    <v-toolbar
        :color="'grey darken-1'"
        dark
    >    
    <v-toolbar-title>검색 결과</v-toolbar-title>
    <v-spacer/>
    <v-btn
        color='#37474F'
        @click="DownloadData_Csv">
        다운로드
        <v-icon>mdi-download</v-icon>
    </v-btn>
    </v-toolbar>
    <v-list>
        <v-data-table         
        :footer-props="{'items-per-page-options':[50, -1]}"
        :headers="headers" 
        :items="filterdData"
        :loading="loadingData"
        >        
        <template v-slot:item="row">            
            <tr>
            <td>{{row.item.event_tag}}</td>
            <td>{{row.item.event_name}}</td>
            <td>{{row.item.count}}</td>
            <td>{{row.item.package}}</td>
            </tr>
        </template>
        </v-data-table>
    </v-list>
    </v-card>
    </div>   
    
</template>

<script>
import { mapActions } from 'vuex';
import moment from 'moment'
import store from '../../store';
import config from '../../config/config';
import { format, parseISO } from 'date-fns'
export default {
    name: 'UserList',

    data: () => ({
        selcetedPackage:'',

        targetUser:'USER_ID',
        isMailAll:false,
        loadingData:false,        
        mailTitle:'',
        mailMessage:'',
        start_date: format(parseISO(new Date().toISOString()), 'yyyy-MM-dd'),
        end_date:format(parseISO(new Date().toISOString()), 'yyyy-MM-dd'),
        date_picker_1: false,
        date_picker_2: false,
        itemInfoList:[
            {
                name:'보석',
                value:'item_type_1',
            },
            {
                name:'골드',
                value:'item_type_2',
            }   
        ],
        selected_itemList:[],   ///인덱스만 담기것지 나중에 전송할때는 한번 가공하도록 한다         
        selected_itemList_count:[],   
        title_type_items:[],    //타이틀 설정 하도록 
        event_history_all:[           
        ]
    }),

    created()
    {
        //this.end_date = moment().add(1,'M').format('yyyy-MM-DD');
        this.start_date = moment().subtract(1,'day').format('yyyy-MM-DD');
        this.end_date = moment().subtract(1,'day').format('yyyy-MM-DD');
        this.OnSearch_Event();
    },

    methods:{
        ...mapActions([
            'GET_LOG_TODAY',
            'GET_LOG'
        ]),
        OnClickUserInfo(_item)
        {
            this.loadingData = true;
            alert(_item.user_id + "의 정보를 확인합니다.");
            //let locateValue  = location.protocol +  "//"+location.host+'/story_eventedit?seq_event_new='+selectItem.seq_event_new;
            //window.location.href = locateValue;
        },
        OnClickUser_Mail(_item)
        {
            this.loadingData = false;
            alert(_item.user_id + "에게 메일을 보내려고합니다.");
        },
        IsActiveState(_item)
        {
            return _item.active_yn=="Y"?true:false;
        },
         OnSearch_Event()
        {
            console.log('이벤트 등록하기');//GET_LOG_TODAY 
            let log_type = 'REGIST';
            this.event_history_all = [];
            //console.log(log_type);
            //start_date, end_date
            let start_date = this.start_date;
            let end_date = this.end_date;
            this.GET_LOG({log_type , start_date, end_date}).then((body_data)=>{
                console.log("GET_LOG"+JSON.stringify(body_data));
                
                let event_info = body_data.event_info;
                let remake_eventInfo ={};// event_info[]
                for(let index in event_info)
                {   
                    remake_eventInfo[event_info[index].event_tag] = event_info[index];
                }
                console.log(JSON.stringify(remake_eventInfo));
                let result = body_data.result;
                for(let index in result)
                {
                    let reportItem = result[index];
                    let eventInfo = remake_eventInfo[reportItem.event_tag];
                    if(eventInfo != undefined)
                    {
                        let event_item = {};
                        event_item['event_tag'] = eventInfo.event_tag;
                        event_item['event_name'] = eventInfo.event_name;
                        event_item['package'] = eventInfo.package;
                        event_item['count'] = reportItem.count;
                        
                        this.event_history_all.push(event_item);
                        console.log(JSON.stringify(reportItem));
                    }
                }
                console.log(JSON.stringify(this.event_history_all));
            });
        },
        OnSearch_Event_Today()
        {//오늘자로만 검색해서 가져오도록 한다                              
            let log_type = 'REGIST';
            this.event_history_all = [];
            console.log(log_type);
            this.GET_LOG_TODAY({log_type}).then((body_data)=>{
                console.log("ADD_LOG_EVENT"+JSON.stringify(body_data));
                
                let event_info = body_data.event_info;
                let remake_eventInfo ={};// event_info[]
                for(let index in event_info)
                {   
                    remake_eventInfo[event_info[index].event_tag] = event_info[index];
                }
                console.log(JSON.stringify(remake_eventInfo));
                let result = body_data.result;
                for(let index in result)
                {
                    let reportItem = result[index];
                    let eventInfo = remake_eventInfo[reportItem.event_tag];
                    if(eventInfo != undefined)
                    {
                        let event_item = {};
                        event_item['event_tag'] = eventInfo.event_tag;
                        event_item['event_name'] = eventInfo.event_name;
                        event_item['package'] = eventInfo.package;
                        event_item['count'] = reportItem.count;
                        
                        this.event_history_all.push(event_item);
                        console.log(JSON.stringify(reportItem));
                    }
                }
                console.log(JSON.stringify(this.event_history_all));
            });
        },
        DownloadData_Csv()
        {
            console.log('이벤트 다운로드 하기 ');
        }

    },
    computed: {
        isLive(){
            return config.isLive;
        },
        computedDateFormattedMomentjs_begin () {
            return this.start_date ? moment(this.start_date).format('YYYY-MM-DD') : ''
        },
        computedDateFormattedMomentjs_end () {
            return this.end_date ? moment(this.end_date).format('YYYY-MM-DD') : ''
        },
        filterdData () {
            return this.event_history_all.filter( item => item.package == this.selcetedPackage)
        },
        filterdPackage () {
            let packages = {}
            this.event_history_all.forEach((item) => {
                if(!packages[item.package]){
                    packages[item.package] = item.package
                }
            })
            packages = Object.values(packages)
            packages = packages.map( (item) => {
                return {"package": item}
            })
            return packages
        },
        totalCount () {
            return this.filterdData[0]?`(${this.filterdData.reduce((p, c, i, a) => {
                return p + parseInt(c.count)
            }, 0).toLocaleString()})`:''
        },
        headers () {
            return [            
            { text: '이벤트 키', value: 'event_key' },
            { text: '이벤트 타이틀', value: 'event_title' },
            { text: `카운트 ${this.totalCount}`, value: 'count' },
            { text: '패키지', value: 'package' },
        ]
        },
    },
    components:{
    },

};
</script>
